import React, { FC, useState, useEffect } from 'react';
import { Row, Button, Select, Upload, notification, Alert, Result, Spin } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import axios, { AxiosRequestConfig } from 'axios';
import { withRouter, RouteComponentProps } from 'react-router';
import _ from 'lodash';
import useAuth from '../auth/use-auth';

const { Option } = Select;

const UploadCredential: FC<RouteComponentProps | any> = (props) => {
  const [selectedDocType, setSelectDocType] = useState<string>('');
  const [docTypesList, setDocTypesList] = useState<any>([]);
  const [fileList, setFileList] = useState<any>([]);
  const [file, setFile] = useState<any>(null);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [docTypeDetails, setDocTypeDetails] = useState<any>(undefined);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const [isUserEligible, setIsUserEligible] = useState<boolean>(false);
  const [ineligibleMessage, setIneligibleMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { userHasValidToken, logout } = useAuth();

  useEffect(() => {
    userHasValidToken() ? canUploadCredentials() : props.history.push('./loggedOut');
  }, []);

  useEffect(() => {
    if (isUserEligible) {
      userHasValidToken() ? getDocumentList() : props.history.push('./loggedOut');
    }
  }, [isUserEligible]);

  const canUploadCredentials = () => {
    const headers: any = {
      VerifToken: sessionStorage.getItem('VerifToken'),
    } as AxiosRequestConfig;

    axios({
      url: '/applicant/CanUploadCredentials',
      baseURL: process.env.REACT_APP_PROXY_URL,
      method: 'post',
      headers: headers,
      data: { test: 'asd' },
      withCredentials: true,
    })
      .then((response: any) => {
        console.log(response);
        if (response.data === '') {
          setIsUserEligible(true);
        } else {
          setIneligibleMessage(response.data);
        }
        setIsLoading(false);
      })
      .catch((ex: any) => {
        console.log(ex);
        setErrorMessage(ex.message);
        setIsLoading(false);
      });
  };

  const getDocumentList = () => {
    setIsLoading(true);
    const headers: any = {
      //"AuthToken": sessionStorage.getItem('AuthToken'),
      VerifToken: sessionStorage.getItem('VerifToken'),
      // Cookie: sessionStorage.getItem("AuthToken")?.toString().substring(4),
    } as AxiosRequestConfig;

    axios({
      url: '/Document/GetPSVDocList',
      baseURL: process.env.REACT_APP_PROXY_URL,
      method: 'post',
      headers: headers,
      data: { test: 'asd' },
      withCredentials: true,
    })
      .then((response: any) => {
        console.log(response);
        setDocTypesList(response.data);
        setIsLoading(false);
      })
      .catch((ex: any) => {
        console.log(ex);
        setErrorMessage(ex.message);
        setIsLoading(false);
      });
  };

  const onSelectDocumentChange = (e: any) => {
    setFileList([]);
    setFile(null);
    var docDetails = _.filter(docTypesList, { DocumentType: e });

    setSelectDocType(e);
    setDocTypeDetails(docDetails[0]);
    setErrorMessage(undefined);
  };

  const handleUpload = () => {
    setIsProcessing(true);
    const headers: any = {
      //"AuthToken": sessionStorage.getItem('AuthToken'),
      VerifToken: sessionStorage.getItem('VerifToken'),
      // Cookie: sessionStorage.getItem("AuthToken")?.toString().substring(4),
    } as AxiosRequestConfig;

    const formD = new FormData();
    const DocDetails = {
      DocumentType: selectedDocType,
    };
    formD.append('DocDetails', JSON.stringify(DocDetails));
    formD.append('file', file);

    axios({
      url: '/Document/UploadPSVFile', //process.env.REACT_APP_AUTHENTICATION_REQUEST,
      baseURL: process.env.REACT_APP_PROXY_URL,
      method: 'post',
      headers: headers,
      data: formD,
      withCredentials: true,
    })
      .then((result: any) => {
        setErrorMessage(undefined);
        setIsProcessing(false);
        setFileList([]);
        setFile(null);
        setSelectDocType('');
        openNotification(result?.data?.UploadSuccessMsg?.toString().replace('<br><br>', ''));
      })
      .catch((exception: any) => {
        console.log('exception: ', exception);
        setIsProcessing(false);
        setErrorMessage(exception.message);
      });
  };

  const openNotification = (message: string) => {
    notification['success']({
      message: 'Success',
      description: message,
      duration: 10,
    });
  };

  const beforeDocumentUpload = (file: any) => {
    const fileSizeLimit = parseInt(docTypeDetails?.FileSizeInKB);
    const isFileTooLarge = file.size / 1024 <= fileSizeLimit;

    setErrorMessage(undefined);
    setFileList([]);
    setFile(null);

    if (!isFileTooLarge) {
      setErrorMessage(`File must be smaller than ${docTypeDetails?.FileSizeInKB} KB`);
      return false;
    }
    if (file.type !== 'application/pdf') {
      setErrorMessage('File must be a pdf');
      return false;
    }

    var files = [file];
    setFile(file);

    setFileList(files);
    setErrorMessage(undefined);
    return false;
  };

  return (
    <>
      {isLoading ? (
        <Spin />
      ) : isUserEligible && ineligibleMessage === '' ? (
        <div
          style={{
            margin: 'auto',
            width: '75%',
            padding: '5px',
          }}
        >
          {errorMessage ? <Alert type="error" message={errorMessage} /> : null}
          <h1>Upload Credentials</h1>
          <Row>Please select the document type you want to upload from the drop-down list below.</Row>
          <br />
          <Select
            style={{ width: 250 }}
            onChange={(e: any) => {
              onSelectDocumentChange(e);
            }}
            value={selectedDocType}
          >
            {docTypesList?.sort().map((documentType: any) => (
              <Option key={documentType.DocumentType} value={documentType.DocumentType}>
                {documentType.DocumentTypeDesc}
              </Option>
            ))}
          </Select>

          {selectedDocType ? (
            <>
              <br />
              <div>
                <b>{docTypeDetails?.DocumentTypeDesc}</b>
              </div>
              <div>{docTypeDetails?.DocInstructions}</div>
              <br />
              <div>Max Size: {docTypeDetails?.FileSizeInKB} KB</div>
              <div>
                Max Height: {docTypeDetails?.MaxHeight} inches / {Math.round(parseFloat(docTypeDetails?.MaxHeight) * 25.4)} mm
              </div>
              <div>
                Max Width: {docTypeDetails?.MaxWidth} inches / {Math.round(parseFloat(docTypeDetails?.MaxWidth) * 25.4)} mm
              </div>
              <div>Acceptable File Format: PDF</div>
            </>
          ) : null}

          <br />
          <div>
            Files cannot be previewed in the tool before they are submitted, and once a file is uploaded, it cannot be recalled or undone. Please confirm you have selected the
            correct document before you upload.{' '}
          </div>
          <br />
          <Upload
            onRemove={(file: any) => {
              setFileList([]);
              setFile(null);
              return true;
            }}
            beforeUpload={(file: any) => {
              beforeDocumentUpload(file);
            }}
            fileList={fileList}
            disabled={!selectedDocType || selectedDocType === ''}
            accept=".pdf"
          >
            <Button
              onClick={(e: any) => {
                if (!userHasValidToken()) {
                  props.history.push('./loggedOut');
                }
              }}
              icon={<UploadOutlined />}
              disabled={!selectedDocType || selectedDocType === ''}
            >
              Select Document
            </Button>
          </Upload>
          <br />
          <Button
            type={'primary'}
            onClick={() => {
              if (!userHasValidToken()) {
                props.history.push('./loggedOut');
              } else {
                handleUpload();
              }
            }}
            disabled={!file}
            loading={isProcessing}
          >
            Upload Document
          </Button>
        </div>
      ) : (
        <Result
          status="warning"
          title={ineligibleMessage}
          extra={
            <Button
              type="primary"
              onClick={(e: any) => {
                logout();
                props.history.push('./loggedOut');
              }}
            >
              Logout
            </Button>
          }
        />
      )}
    </>
  );
};

export default withRouter(UploadCredential);
